import { call, takeLatest, put } from "redux-saga/effects";
import * as Sentry from "@sentry/react";
import {
  INITIATE_VIEW_MEMBER_DATA,
  SET_VIEW_MEMBER_DATA,
  SET_VIEW_MEMBER_DATA_FAIL,
  SET_VIEW_MEMBER_PAGE_DATA,
} from "../../actionTypes/dashboard";
import Member from "../../../services/api/member";

// onSuccess handler for pending transfer data api
const onPendingTransferDataSuccess = (payload) => ({
  type: SET_VIEW_MEMBER_DATA,
  payload,
});

const onPendingTransferPageData = (payload) => ({
  type: SET_VIEW_MEMBER_PAGE_DATA,
  payload,
});

// onFail handler for pending transfer data api
const onPendingTransferDataFail = (payload) => ({
  type: SET_VIEW_MEMBER_DATA_FAIL,
  payload,
});

/**
 * This function handles the pending friends data api and sets the data in reducer accordingly
 *
 * @param {object} action contains the data required for this generator function
 */
function* getPendingTransferData(action) {
  try {
    const response = yield call(Member.getPendingTransfer, action.payload);
    yield put(
      onPendingTransferDataSuccess({
        ...response,
        paginationInfo: {
          currentPage: Number(response.number),
          totalPages: Number(response.totalPages),
          totalElements: Number(response.totalElements),
          pageSize: Number(response.size),
        },
      })
    );
    yield put(
      onPendingTransferPageData({
        paginationInfo: {
          currentPage: Number(response.number),
          totalPages: Number(response.totalPages),
          totalElements: Number(response.totalElements),
          pageSize: Number(response.size),
        },
      })
    );
  } catch (error) {
    yield put(onPendingTransferDataFail(error));
    Sentry.captureException(error);
  }
}

/**
 * Watcher saga for friends
 */
function* watchFriendsSaga() {
  yield takeLatest(INITIATE_VIEW_MEMBER_DATA, getPendingTransferData);
}
export default watchFriendsSaga;
